module.exports = __webpack_public_path__ + "img/540524.777bcbde.png";